// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-form-page-js": () => import("./../src/templates/form-page.js" /* webpackChunkName: "component---src-templates-form-page-js" */),
  "component---src-templates-info-page-js": () => import("./../src/templates/info-page.js" /* webpackChunkName: "component---src-templates-info-page-js" */)
}

